import { Component, Output, EventEmitter, Inject, OnInit, Input } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { CompanyService, CustomerService, SharedService } from "src/app/services";
import { WebCompany, WebCustomer, WebSettings } from "../../../models";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-request-service-dialog",
  templateUrl: "./request-service-dialog.component.html",
  styleUrls: ["./request-service-dialog.component.scss"],
})
export class RequestServiceDialogComponent implements OnInit
{

  customer: WebCustomer;
  company: WebCompany;
  customerSubscription: Subscription;
  companySubscription: Subscription;

  title = "Request Service";
  showHeaderInfo: boolean;

  showDefaultDisclaimerText: boolean;
  webSettingsSubscription: Subscription;
  swoDisclaimer: SafeHtml;
  webSettings: WebSettings;

  constructor(
    public dialogRef: MatDialogRef<RequestServiceDialogComponent>,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private sharedService: SharedService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void
  {

    this.showHeaderInfo = true;

    this.webSettingsSubscription = this.companyService.webSettings.subscribe(s =>
    {
      this.webSettings = s;
      const parser = new DOMParser();
      const doc = parser.parseFromString(s?.SWODisclaimer || '', 'text/html');
      const hasImage = doc.querySelector('img') !== null;
      const isDisclaimerTextMissing = !s?.SWODisclaimerText || s?.SWODisclaimerText.trim().length < 1;
      if (!hasImage && isDisclaimerTextMissing)
      {
        this.showDefaultDisclaimerText = true;
      }
      else
      {
        this.showDefaultDisclaimerText = false;
        this.setSWODisclaimer();
      }
    });

    this.customerSubscription = this.customerService.customer.subscribe(customer =>
    {
      this.customer = customer;
    });


    this.companySubscription = this.companyService.company.subscribe(c =>
    {
      this.company = c;
    });

  }

  setSWODisclaimer(): void
  {
    const rawDisclaimer = this.webSettings.SWODisclaimer;
    const edited = this.editDisclaimer(rawDisclaimer);
    this.swoDisclaimer = this.sanitizer.bypassSecurityTrustHtml(edited);
  }


  editDisclaimer(content: string): string
  {
    let newString = content;

    if (this.sharedService.isDark)
    {
      newString = newString.replace("body { ", "body { color: #ffffff !important; ");
      newString = newString.replace(/color:\s*#000000/gi, "color: #ffffff");
      newString = newString.replace(/color:\s*#333333/gi, "color: #ffffff");
    }

    newString = newString.replace(/verdana|arial|calibri/gi, "Roboto");

    return newString;
  }

  ngOnDestroy(): void
  {
    this.webSettingsSubscription?.unsubscribe();
    this.companySubscription?.unsubscribe();
    this.customerSubscription?.unsubscribe();
  }
}
